<script lang="ts">
  import BackButton from './BackButton.svelte';

  /**
   * 共通ヘッダー。各ページはこれを使ってタイトルと「戻る」導線を表示する。
   * - `showBack` を true にすると左側に BackButton を表示する（サマリー画面など最上位のページでは false）。
   * - `backTo` を指定すると戻り先を固定できる（省略時は履歴を1つ戻る）。
   * - `slot` (right) を使うと右側にアクション（例: 追加ボタン）を配置できる。
   */
  interface Props {
    title: string;
    showBack?: boolean;
    backTo?: string;
    right?: import('svelte').Snippet;
  }

  let { title, showBack = false, backTo = undefined, right }: Props = $props();
</script>

<header class="app-header">
  <div class="app-header__side app-header__side--left">
    {#if showBack}
      <BackButton to={backTo} />
    {/if}
  </div>
  <h1 class="app-header__title">{title}</h1>
  <div class="app-header__side app-header__side--right">
    {#if right}
      {@render right()}
    {/if}
  </div>
</header>

<style>
  .app-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 0.5rem;
    background-color: var(--color-bg);
    color: var(--color-text);
    border-bottom: 1px solid var(--color-border);
    position: sticky;
    top: 0;
    z-index: 10;
  }

  .app-header__side {
    min-width: 2.75rem;
    display: flex;
    align-items: center;
  }

  .app-header__side--right {
    justify-content: flex-end;
  }

  .app-header__title {
    flex: 1;
    text-align: center;
    font-size: 1.05rem;
    font-weight: 600;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
